import { useMemo } from 'react';

import { SecondaryButton } from '@pulse-web-ui/button-v2';
import { typography } from '@pulse-web-ui/theme';
import type { TooltipProps } from '@pulse-web-ui/tooltip';

export const useGetProfileSectionHeaderStyles = ({
  title,
  fontSize: fontSizeProp,
  marginBottom: marginBottomProp,
  isSubmitSection,
  isDesktop,
  buttonProps,
  titleTooltipProps,
}: {
  title?: string;
  fontSize?: string;
  marginBottom?: number;
  isDesktop?: boolean;
  isSubmitSection?: boolean;
  buttonProps?: React.ComponentProps<typeof SecondaryButton>;
  titleTooltipProps?: TooltipProps;
}) => {
  const fontSize =
    fontSizeProp ??
    (isSubmitSection
      ? isDesktop
        ? typography.medium20
        : typography.medium18
      : undefined);

  const marginBottom = marginBottomProp ?? (isSubmitSection ? 16 : undefined);

  return useMemo(
    () => ({
      title,
      fontSize,
      marginBottom,
      buttonProps,
      titleTooltipProps,
    }),
    [
      title,
      isDesktop,
      buttonProps,
      titleTooltipProps,
      fontSizeProp,
      marginBottomProp,
    ]
  );
};
